import { getEnabledElement } from "component/toolManager/enabledElements.js";
import { updateEnabledElement } from "component/toolManager/enabledElements.js";

export default function (synchronizer, sourceElement, targetElement) {
  // Ignore the case where the source and target are the same enabled element
  if (targetElement === sourceElement) {
    return;
  }

  // Element 정보 획득
  let sourceElementStub = getEnabledElement(sourceElement);
  let targetElementStub = getEnabledElement(targetElement);

  // Get the source and target viewports
  const sourceViewport = sourceElementStub.viewport;
  const targetViewport = targetElementStub.viewport;

  if (
    sourceViewport === null ||
    sourceViewport === undefined ||
    targetViewport === null ||
    targetViewport === undefined
  ) {
    return;
  }

  // Do nothing if the scale and translation are the same
  if (
    targetViewport.scale === sourceViewport.scale &&
    targetViewport.translation.x === sourceViewport.translation.x &&
    targetViewport.translation.y === sourceViewport.translation.y
  ) {
    return;
  }

  // Scale and/or translation are different, sync them
  targetViewport.scale = sourceViewport.scale;
  targetViewport.translation.x = sourceViewport.translation.x;
  targetViewport.translation.y = sourceViewport.translation.y;
  targetElementStub.needsRedraw = true;
  updateEnabledElement(sourceElementStub);
}
